/* eslint-disable */
import React, { useRef } from 'react';
import { SearchInput, Button, Tooltip } from '@patternfly/react-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import './SearchInput.scss';

interface ChartTypeSearchInputProps {
	value: string;
	onChange: (value: string) => void;
	onClear?: () => void;
	placeholder?: string;
}

export const ChartTypeSearchInput: React.FC<ChartTypeSearchInputProps> = ({
	value,
	onChange,
	onClear,
	placeholder = 'Search chart types...',
}) => {
	const clearButtonRef = useRef<HTMLButtonElement>(null);

	return (
		<div className="chart-type-search-input">
			<SearchInput
				placeholder={placeholder}
				value={value}
				onChange={(_e, val) => onChange(val)}
				onClear={onClear}
			/>
			{value && (
				<>
					<Button
						ref={clearButtonRef}
						className="clear-button"
						variant="plain"
						onClick={onClear}
						aria-label="Clear search"
					>
						<FontAwesomeIcon icon={faXmark} />
					</Button>
					<Tooltip
						content="Clear search"
						reference={clearButtonRef}
					/>
				</>
			)}
		</div>
	);
};
